import { createFileRoute } from "@tanstack/react-router";

import { AccountDetailsPage } from "@pages/account-details/account-details-page";

export const Route = createFileRoute(
  "/_authenticated/app/accounts/$accountId/",
)({
  component: AccountDetailsPage,
});
